import { Component} from '@angular/core';
import { NavController,App } from 'ionic-angular';
import { AppState } from '../../../app/app.global';
import { JpushService } from '../../../providers/service/jpushservice';
import {CameraPage} from '../../test/camera/camera'
import {GeolocationPage} from '../../test/geolocation/geolocation'
import {MapPage} from '../../test/map/map'

@Component({
  selector: 'jpush-index',
  templateUrl: 'jpush.html'
})

export class JpushPage {
	constructor (public navCtrl: NavController,public global: AppState,public jpush: JpushService,public appCtrl: App) {

  }

	init(){
		this.jpush.initJpush();
	}
	getRegistrationID(){
		this.jpush.getRegistrationID();
	}
  setTag(){
  	this.jpush.setTags();
  }

  setAlias(){
  	this.jpush.setAlias("45");
  }

  cameraTest(){
  	this.appCtrl.getRootNav().push(CameraPage);
  }

  getlocal(){
  	this.appCtrl.getRootNav().push(GeolocationPage);
  }

  getMap(){
  	this.appCtrl.getRootNav().push(MapPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/about/jpush/jpush.ts